import React, { Component, Fragment } from 'react';
import * as HMS from "../../../common/component/Index";
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import * as Func from '../../../../../helpers/functions';
import Rate from "./../../../../../models/Rate";
import isEqual from "lodash/isEqual";
import { DETAIL_ACTIONS, PATHS, FEATURE_FLAGS, HOTEL, RATE_ENUM, DATE_TIME_FORMAT } from '../../../../../constants/Define';
import { cloneDeep, toArray } from 'lodash';
import TranslateButton from '../../../common/component/TranslateButton';
import Wrapper from '../../../common/component/Wrapper';
import { Input, Switch, Icon, InputNumber, Button, Tooltip, Tag, Tabs } from 'antd';
import './style.less';
import CONFIG from '../../../../../constants/Config';
import EllipsisText from '../../../common/component/EllipsisText';
import moment from 'moment';
import AutoTranslateField from './Components/AutoTranslateField';
import PriceConfig from './Components/PriceConfig/PriceConfig';
import AutoTranslate from 'containers/backend/common/component/AutoTranslate/AutoTranslate';
import OperatingHoursTable from './Components/OperatingHoursTable';

const ListCols = ['rangeDate', 'from', 'to', 'weekdays', 'daysBeforeArrival', 'amount', 'type', 'isActive'];
const { TabPane } = Tabs;
const TERMS_DESCRIPTION_OPTIONAL_NOTE = 'Trường này không bắt buộc. Nếu bỏ trống, điều khoản mặc định đã cấu hình ở khách sạn sẽ được sử dụng';
const WEEKDAY_OPTIONS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

const formatWeekdays = (weekdays = '') => {
    const weekdayValues = Array.isArray(weekdays) ? weekdays : `${weekdays}`.split(',');
    return [...new Set(weekdayValues
        .map(day => Number(`${day}`.trim()))
        .filter(day => day >= 1 && day <= 7)
        .sort((dayA, dayB) => dayA - dayB))]
        .map(day => WEEKDAY_OPTIONS[day - 1]);
};

class TableCancelPolicy extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], ['from', 'to', 'isActive']),
            componentTable: {
                rangeDate: {
                    key: 'rangeDate',
                    width: 200,
                    render: (text, record) => (
                        <span>{record.from && moment(record.from).format(DATE_TIME_FORMAT.SHORT_DATE)}
                         { record.to && ` - ${moment(record.to).format(DATE_TIME_FORMAT.SHORT_DATE)}`}
                        </span>
                    ),
                },
                weekdays: {
                    key: 'weekdays',
                    width: 240,
                    render: (text, record) => {
                        const weekdayKeys = formatWeekdays(record.weekdays);

                        if (!weekdayKeys.length) {
                            return '--';
                        }

                        if (weekdayKeys.length === WEEKDAY_OPTIONS.length) {
                            return <Tag className="cancel-policy-weekday-tag">{this.props.t('item.ticket.allDay')}</Tag>;
                        }

                        return (
                            <div className="cancel-policy-weekdays">
                                {weekdayKeys.map(dayKey => (
                                    <Tag key={dayKey} className="cancel-policy-weekday-tag">
                                        {this.props.t(`item.ticket.${dayKey}`)}
                                    </Tag>
                                ))}
                            </div>
                        );
                    },
                },
                daysBeforeArrival: {
                    key: 'daysBeforeArrival',
                    width: 150,
                },
                amount: {
                    key: 'amount',
                    width: 120,
                    render: (text, record, idx) => {
                        return(
                            this.state.indexEdit === idx ?
                                <InputNumber
                                    style={{width: '100%'}}
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    name={`amount`}
                                    value={record.amount}
                                    onChange={(e) => this.onChange('amount', idx, e)}
                                />
                                : <div>{Func.formatMoney(record.amount)}</div>
                        )
                    },
                },
                type: {
                    key: 'type',
                    width: 120,
                    render: (text, record, idx) => {
                        return(
                            this.state.indexEdit === idx ?
                                <AntSelect className="select-types"
                                    showArrow
                                    placeholder={ Func.capitalizeFirstLetter((this.props.t('placeHolderForm.select') + " " + this.props.t("item.rate.cancelPolicy.value")).toLowerCase()) }
                                    value={record.type}
                                    onChange={ channel => this.onChange('type', idx, channel) }
                                    style={ { width: '100%' } }
                                >
                                    { this.getValueEnums().map(vl => (
                                        <AntOption key={ vl.id } value={ vl.value }>
                                            { this.props.t(`item.rate.cancelPolicyObject.valueOption.${vl.label}`) }
                                        </AntOption>
                                    )) }
                                </AntSelect>
                                : <div>
                                    { RATE_ENUM.VALUE_CANCEL_POLICY[record.type] &&
                                    this.props.t(`item.rate.cancelPolicyObject.valueOption.${RATE_ENUM.VALUE_CANCEL_POLICY[record.type].label}`) }
                                </div>
                        )
                    },
                },
                action: {
                    align: 'center',
                    key: 'isActive',
                    width: 100,
                    render: (text, record, idx) => {
                        return(
                            this.state.indexEdit !== idx ? <Switch
                                checked={record.isActive}
                                onChange={(value, e) => this.onChange('isActive', idx, value)}
                                name={`isActive`}
                            />
                            :  <Icon
                                type={this.props.rateState.isFetchingCancelPolicy ? "loading" : "check"}
                                className="policy-update-btn"
                                onClick={()=>this.onUpdateCancelPolicy(this.state.arrCancelPolicy)}
                            />
                        )
                    },
                }
            },
            indexEdit: null,
            arrCancelPolicy: []
        };
    }

    componentDidMount(){
        if(this.props.cancelPolicyData){
            this.setState({arrCancelPolicy: this.props.cancelPolicyData.details || []});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.cancelPolicyData, this.props.cancelPolicyData)) {
            this.setState({
                arrCancelPolicy: nextProps.cancelPolicyData ? nextProps.cancelPolicyData.details : [],
            });
        }
    }

    getValueEnums() {
        return toArray(RATE_ENUM.VALUE_CANCEL_POLICY);
    }

    onChange = (field, idx, value) => {
        let arrCancelPolicy = this.state.arrCancelPolicy;
        if(arrCancelPolicy.length > 0){
            arrCancelPolicy[idx][field] = value;
        }
        if(field === 'isActive'){
            this.onUpdateCancelPolicy(arrCancelPolicy);
        }
        this.setState({ arrCancelPolicy });
    };

    handleRowSelection = (value)=>{
       this.setState({indexEdit: value});
    }

    onUpdateCancelPolicy = (arrCancelPolicy)=>{
        const { cancelPolicyData } = this.props;
        const { match } = this.props;
        let request = {
            ...cancelPolicyData,
            details: arrCancelPolicy
        }
        match.params.id && this.props.updateCancelPolicys(request, match.params.id);
        this.setState({indexEdit: null, arrCancelPolicy: this.props.cancelPolicyData.details});
    }

    onSyncRRMCancelPolicy = ()=>{
        const { refId } = this.props;
        const { match } = this.props;
        let request = {
            hotelId: match.params.hotel_id,
            ratePlanId: refId
        }
        match.params.hotel_id && match.params.id && this.props.syncCancelPolicys(request, match.params.id);
    }

    render(){
        const { t, rateState } = this.props;
        const {
            componentTable,
            titleItemTable,
            arrCancelPolicy
        } = this.state;

        return(
            <div className="component-table-cancel-policy">
                <div className="header-policy">
                    <div className="left-policy">
                        {t(`item.rate.cancelPolicyObject.tableValue`)}&nbsp;
                        {this.props.cancelPolicyData && <Tag color="green">
                            {this.props.cancelPolicyData?.id}
                        </Tag>}
                    </div>
                    <div className="right-policy">
                        <Tooltip title={t(`item.rate.cancelPolicyObject.sync`)}>
                            <Icon type="sync" onClick={()=>this.onSyncRRMCancelPolicy()}/>
                        </Tooltip>
                    </div>
                </div>

                <HMS.ListComponent
                    tableKey="room-type-list"
                    classChildren="p-0" classParent="m-0"
                    rowKey={(record, k) => record.id ? record.id : k}
                    loading={{ spinning: rateState.isFetchingCancelPolicy, size: 'large' }}
                    dataSource={ Func.getDataSource(arrCancelPolicy || [], ListCols) }
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'rate.cancelPolicyObject'
                    })}
                    bordered
                    scroll={{ x: 'max-content' }}
                    onRow={(record, index) => ({
                        onDoubleClick: (e) => this.handleRowSelection(index)
                    })}
                />
            </div>
        )
    }
}

class DescriptionRate extends Component {
    constructor(props){
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(['icon', 'shortDescription'], ['action'], []),
            componentTable: {
                icon: {
                    key: 'icon',
                    render: (icon, record)=> {
                        return icon && <img width={20} alt="" src={icon}/>
                    }
                },
                shortDescription: {
                    key: 'shortDescription',
                    render: (shortDescription)=> shortDescription &&
                    <EllipsisText title={shortDescription} content={shortDescription} contentMaxWidth={280} overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                action: {
                    width: 100,
                    key: 'action',
                    align: 'center',
                    render: (text, record, idx)=> <Icon type="delete" style={{cursor: 'pointer'}}
                        onClick={()=>this.removeItem(idx)}
                    />
                }
            },
            arrShortDescription: [],
            description: {
                icon: null,
                shortDescription: null
            }
        }
    }

    componentDidMount(){
        if(this.props.shortDescription){
            let arrTmp = this.props.shortDescription;
            if(typeof this.props.shortDescription === 'string'){
                arrTmp = [{icon: null, shortDescription: this.props.shortDescription}];
            }
            this.setState({arrShortDescription: arrTmp || []});
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(nextProps.shortDescription, this.props.shortDescription)) {
            let arrTmp = nextProps.shortDescription;
            if(typeof nextProps.shortDescription === 'string'){
                arrTmp = [{icon: null, shortDescription: nextProps.shortDescription}];
            }
            this.setState({arrShortDescription: arrTmp || []});
        }
    }

    onAddDescription = ()=>{
        const { arrShortDescription, description } = this.state;
        let arrOld = arrShortDescription;
        if(description.icon && description.shortDescription.trim()){
            if(description.icon){
                const { amenityState } = this.props;
                const { amenities } = amenityState;
                const findIndex = amenities.findIndex(item => item.id === description.icon);
                description['icon'] = amenities[findIndex].url ? this.convertUrlImage(amenities[findIndex].url) : '';
            }

            arrOld = [
                ...arrShortDescription,
                description
            ]
            this.props.addDescription(arrOld);
            this.setState({
                arrShortDescription: arrOld ,
                description: {
                    icon: null,
                    shortDescription: null
                }
            });
        }
    }

    removeItem = (idx)=>{
        const { arrShortDescription } = this.state;
        if(idx !== null){
            arrShortDescription.splice(idx, 1);
            this.setState({arrShortDescription})
            this.props.addDescription(arrShortDescription);
        }
    }

    onChange = (fieldName, value)=>{
        const { description } = this.state;
        description[fieldName] = value;
        this.setState({ description })
    }

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode((option?.props?.children[0] || '').toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    convertUrlImage(url) {
        return url.includes('https://') ? url : `https://${url}`
    }

    render(){
        const {
            titleItemTable,
            componentTable,
            arrShortDescription,
            description
        } = this.state;

        const { t, amenityState, hotelState } = this.props;
        const { amenities, isFetching } = amenityState;

        return(
            <div>
                <div className="row">
                    <Wrapper className="col-md-5">
                        <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.rate.descriptionRate.icon`)}
                        >
                            <AntSelect className="select-departure"
                                showArrow showSearch
                                disabled={this.props.disabled}
                                suffixIcon={<Icon type="search" />}
                                placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.bundle.campaign")).toLowerCase()) }
                                onChange={ (e) => {
                                    const iconNameFill = (amenities || []).find(item => item.id === e);
                                    this.onChange('icon', e);
                                    this.onChange('shortDescription', iconNameFill?.name)
                                } }
                                style={ { width: '100%' } }
                                value={ description.icon }
                                loading={ isFetching }
                                filterOption={ (inputValue, option) => this.selectFilterSearch(inputValue, option) }
                            >
                                { (amenities || []).filter(item => item.isActive).map(a => (
                                    <AntOption key={ a.id } value={ a.id }>
                                       {a.name} &nbsp;&nbsp;{a.url && <img width={20} src={this.convertUrlImage(a.url)}/>}
                                    </AntOption>
                                )) }
                            </AntSelect>
                        </HMS.FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-5">
                        <HMS.FormWrapperInputComponent
                            labelTitle={t(`item.rate.descriptionRate.shortDescription`)}
                        >
                            <Input placeholder="" type={`text`}
                                disabled={this.props.disabled}
                                className={`form-control`}
                                name={`name`} onChange={(e) => this.onChange('shortDescription', e.target.value)}
                                value={Func.checkUndefine(description.shortDescription)}
                            />
                        </HMS.FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-2 button-add-center-rate">
                        <Button disabled={!description.icon || !description.shortDescription || (description.shortDescription && !description.shortDescription.trim())} type="primary" onClick={this.onAddDescription}>{t(`item.rate.descriptionRate.add`)}</Button>
                    </Wrapper>
                </div>
                <HMS.ListComponent
                    tableKey="room-type-list"
                    classChildren="p-0" classParent="m-0"
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={ Func.getDataSource(arrShortDescription || [], ['icon', 'shortDescription']) }
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'rate.descriptionRate'
                    })}
                    bordered
                />
            </div>
        )
    }
}

export default class RoomTypeDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {},
            action: this.props.match.params.id ? DETAIL_ACTIONS.UPDATE : DETAIL_ACTIONS.CREATE,
            rate: new Rate(),
            validation: {},
            isUploading: false,
            isReady: !this.props.match.params.id, //Render when create
            rateBeachVilla: {
                name: '',
                code: '',
                description: '',
                promotionalDescription: '',
                termsDescription: '',
                shortDescription: {},
            },
            activeTab: "RATE",
        };
    }

    onChange = (field, value) => {
        const rate = this.state.rate;
        if(field === 'cancelPolicy'){
            rate[field].description = value;
        }else{
            rate[field] = value;
        }
        this.setState({ rate, isSubmit: false });
    };

    _addDescription = (arr)=>{
        this.onChange('shortDescription', arr);
    }

    componentDidMount() {
        const { match } = this.props;
        match.params.id && this.props.getRate(match.params.id);
        match.params.hotel_id && this.props.getHotelDetail(match.params.hotel_id);
        this.props.getListAmenities();
    }

    onClickBack = () => {
        const { match } = this.props;
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            if (Object.keys(match.params).length > 0 && match.params.hotel_id) {
                const path = Func.getPathWithParams(PATHS.RATE.LIST.path, { hotel_id: match.params.hotel_id })
                this.props.history.push(path);
            }
        }
    }

    onShowTranslate = (language) => {
        const { rate } = this.state;
        rate.setTranslate(language.code);
        rate.setData();
        this.setState({ rate, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = (isUpdateTrans = false) => {
        const rate = cloneDeep(this.state.rate);
        const action = DETAIL_ACTIONS[rate.id ? 'UPDATE' : 'CREATE'];
        // if(isUpdateTrans)
        rate.setTranslate(undefined, true);
        rate.setData();
        this.setState({ rate, action });
    }

    onSaveTranslate = () => {
        const { rate } = this.state;
        const getDataTranslation = rate.translations.filter(item => item.languageCode === rate.translate.languageCode)
        const translateFunction = getDataTranslation.length > 0 ? this.props.updateRateTranslate : this.props.createRateTranslate;
        translateFunction(rate, rate.languageCode);
        this.onExitTranslate(true);
    }

    onRemoveTranslate = (language) => {
        const { rate } = this.state;
        rate.setTranslate(language.code);
        this.props.deleteRateTranslate(rate, { id: rate.id });
    }

    onSubmit = async (e) => {
        e.preventDefault();

        const { hotelState, match } = this.props;
        const { action, rate } = this.state;

        const targetLanguages = rate.targetLanguage;
        delete rate['targetLanguage'];
        
        const getDataTranslation = rate.translations.filter(item => item.languageCode === rate.translate.languageCode)
        
        if (hotelState?.detail?.hotel?.isBeachVilla && action === DETAIL_ACTIONS.CREATE) {
            const rateBeachVilla = {
                name: rate.name,
                code: rate.code,
                description: rate?.description,
                promotionalDescription: rate?.promotionalDescription,
                termsDescription: rate?.termsDescription,
                shortDescription: rate.shortDescription ? rate.shortDescription : [],
                status: 1,
                usageStatus: 1,
            }
            this.props.createRateBeachVilla(match.params.hotel_id, rateBeachVilla);
        } else {
            const updateRateBearchVilla = cloneDeep(rate)
            if (hotelState?.detail?.hotel?.isBeachVilla) {
                updateRateBearchVilla.status = 1;
                updateRateBearchVilla.usageStatus = 1;
            }
            const translateFunction = getDataTranslation.length > 0 ? this.props.updateRateTranslate : this.props.createRateTranslate;
            translateFunction(hotelState?.detail?.hotel?.isBeachVilla ? updateRateBearchVilla : rate, rate.languageCode, targetLanguages);
        }
        this.onExitTranslate();
    }

    onChangeTab = (keyActive) => {
        this.setState({ activeTab: keyActive });
        if (keyActive === 'RATE') {
            this.setState({ activeTab: "RATE" });
        } else if (keyActive === 'PRICE_CONFIG') {
            this.setState({ activeTab: "PRICE_CONFIG" });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.rateState.rate && !isEqual(nextProps.rateState.rate, this.props.rateState.rate) && !nextProps.rateState.isFetching) {
            this.setState({
                rate: nextProps.rateState.rate,
                isReady: true,
                loading: false,
                isSubmit: false
            });
        }
    }

    validate() {
        const { t, hotelState } = this.props;
        let validate = {
            required: {
                name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.rate.name`)),
                code: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.rate.code`)),
                promotionalDescription: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.rate.descriptionPromotions`)),
            }
        };
        if (this.state.action === DETAIL_ACTIONS.CREATE && !hotelState?.detail?.hotel?.isBeachVilla) {
            validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
        }
        let valueValidate = {};
        const result = Func.multipleValidate(this.state.rate, validate, valueValidate);
        this.setState({ validation: result });
        return Object.keys(result).length < 1;
    }

    isDisableField(fieldName = '') {
        return false;
    }

    renderTermsDescriptionLabel = () => (
        <Fragment>
            {this.props.t(`item.rate.descriptionTerms`)}
            <br />
            <span className="rate-detail-field-note" style={{fontStyle: 'italic'}} >{TERMS_DESCRIPTION_OPTIONAL_NOTE}</span>
        </Fragment>
    )

    render() {
        const { t, match, hotelState } = this.props;
        const { action, rate, isReady, isSubmit, validation, activeTab } = this.state;
        
        return (
            <Fragment>{isReady &&
                <HMS.PageListComponent className="rate-detail">
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'room-types'}
                        titleHeader={Func.capitalizeFirstLetter(`${(`${t(action === DETAIL_ACTIONS.CREATE ? 'action.create' : 'action.update')} ${t('item.rate.title')}`).toLowerCase()} - ${hotelState?.detail?.hotel?.name || ""}`)}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                            !(hotelState?.detail?.hotel?.isBeachVilla && action === DETAIL_ACTIONS.CREATE) &&
                            <TranslateButton
                                languages={rate.translations}
                                current={rate.languageCode}
                                validation={validation.languageCode}
                                onChange={this.onShowTranslate}
                                onClear={this.onExitTranslate}
                                defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                onSelectDefault={language => this.onChange({ name: 'languageCode', value: language.code })}
                                disabledActionRemove
                                onRemove={this.onRemoveTranslate} 
                            />
                        }
                    />
                    {
                        hotelState?.detail?.hotel?.isBeachVilla ? 
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={false}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={t(`action.save`)}
                            activeComponent={false}
                            submitButtonRight={true}
                        >
                            <div className='basic-info'>
                                <div className='basic-info-box'>
                                    <Tabs defaultActiveKey={activeTab} onChange={this.onChangeTab} activeKey={activeTab} animated={false}>
                                        <TabPane tab={t('item.rate.rateInfo')} key="RATE">
                                            <Wrapper className="row">
                                                <Wrapper className="col-md-6">
                                                    <Wrapper className="row">
                                                        <Wrapper className="col-md-6">
                                                            <HMS.FormWrapperInputComponent
                                                                isRequired={true}
                                                                isValidation={true}
                                                                dataValidation={rate.name}
                                                                validation={validation.name}
                                                                labelTitle={t(`item.rate.name`)}
                                                            >
                                                                <Input placeholder="" type={`text`}
                                                                    className={`form-control`}
                                                                    disabled={this.isDisableField('name')}
                                                                    name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                                                    value={Func.checkUndefine(rate.name)}
                                                                />
                                                            </HMS.FormWrapperInputComponent>
                                                        </Wrapper>
                                                        <Wrapper className="col-md-6">
                                                            <HMS.FormWrapperInputComponent
                                                                isRequired={true}
                                                                isValidation={true}
                                                                dataValidation={rate.code}
                                                                validation={validation.code}
                                                                labelTitle={t(`item.rate.code`)}
                                                            >
                                                                <Input placeholder="" type={`text`}
                                                                    className={`form-control`}
                                                                    name={`name`} onChange={(e) => this.onChange('code', e.target.value)}
                                                                    disabled={action !== DETAIL_ACTIONS.CREATE}
                                                                    value={Func.checkUndefine(rate.code)}
                                                                />
                                                            </HMS.FormWrapperInputComponent>
                                                        </Wrapper>
                                                    </Wrapper>
                                                    <Wrapper>
                                                        <HMS.FormWrapperInputComponent
                                                            isRequired={true}
                                                            isValidation={true}
                                                            dataValidation={rate.promotionalDescription}
                                                            validation={validation.promotionalDescription}
                                                            labelTitle={t(`item.rate.descriptionPromotions`)}
                                                        >
                                                            <Input.TextArea rows={3} placeholder="" type={`text`}
                                                                className='form-control'
                                                                disabled={this.isDisableField('promotionalDescription')}
                                                                name='promotionalDescription' onChange={(e) => this.onChange('promotionalDescription', e.target.value)}
                                                                value={rate.promotionalDescription} />
                                                        </HMS.FormWrapperInputComponent>
                                                    </Wrapper>
                                                    <Wrapper>
                                                        <HMS.FormWrapperInputComponent
                                                            labelTitle={this.renderTermsDescriptionLabel()}
                                                        >
                                                            <Input.TextArea rows={3} placeholder="" type={`text`}
                                                                className='form-control'
                                                                disabled={this.isDisableField('termsDescription')}
                                                                name='termsDescription' onChange={(e) => this.onChange('termsDescription', e.target.value)}
                                                                value={rate.termsDescription} />
                                                        </HMS.FormWrapperInputComponent>
                                                    </Wrapper>
                                                   
                                                    <Wrapper>
                                                        <div className='independent'>
                                                            <HMS.FormWrapperInputComponent
                                                                labelTitle={t(`item.rate.isIndependent`)}
                                                            >
                                                                <br />
                                                                <Switch
                                                                    checked={rate.isIndependent}
                                                                    onChange={(value) => this.onChange('isIndependent', value)}
                                                                    name={`isIndependent`}
                                                                />
                                                            </HMS.FormWrapperInputComponent>
                                                        </div>
                                                    </Wrapper>
                                                   
                                                </Wrapper>
                                                <Wrapper className="col-md-6">
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.rate.shortDescription`)}
                                                    >
                                                        <DescriptionRate
                                                            {...this.props}
                                                            disabled={this.isDisableField('shortDescription')}
                                                            shortDescription={rate.shortDescription}
                                                            addDescription={this._addDescription}
                                                        />
                                                    </HMS.FormWrapperInputComponent>
                                                </Wrapper>
                                                <Wrapper className="col-md-12">
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.rate.dayOfWeek`)}
                                                    >
                                                        <OperatingHoursTable
                                                            t={t}
                                                            value={rate.operatingHours}
                                                            onChange={(value) => this.onChange('operatingHours', value)}
                                                            disabled={this.isDisableField('operatingHours')}
                                                        />
                                                    </HMS.FormWrapperInputComponent>
                                                </Wrapper>

                                                {action === DETAIL_ACTIONS.UPDATE && (
                                                    <AutoTranslate
                                                        className="wrapper-full"
                                                        languageCode={rate?.languageCode || 'vi-VN'}
                                                        onChange={this.onChange}
                                                        targetLanguage={rate?.targetLanguage}
                                                    />
                                                )}
                                            </Wrapper>
                                        </TabPane>
                                        {
                                            (action === DETAIL_ACTIONS.UPDATE || action === DETAIL_ACTIONS.TRANSLATE) && 
                                            <TabPane tab={t('item.rate.priceConfig.title')} key="PRICE_CONFIG">
                                                <PriceConfig
                                                    hotelId={match.params.hotel_id}
                                                    ratePlanId={match.params.id}
                                                />
                                            </TabPane>
                                        }
                                    </Tabs>
                                </div>
                            </div>
                        </HMS.FormActionComponent> : 
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={false}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={t(`action.save`)}
                            activeComponent={false}
                            submitButtonRight={true}
                        >
                            <div className="basic-info">
                                <div className="basic-info-box">
                                    <div className="row">
                                        <Wrapper className="col-md-3">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={rate.name}
                                                validation={validation.name}
                                                labelTitle={t(`item.rate.name`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    disabled={this.isDisableField('name')}
                                                    name={`name`} onChange={(e) => this.onChange('name', e.target.value)}
                                                    value={Func.checkUndefine(rate.name)} />
                                            </HMS.FormWrapperInputComponent>
                                        </Wrapper>
                                        <Wrapper className="col-md-3">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.rate.code`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`name`} onChange={(e) => this.onChange('code', e.target.value)}
                                                    disabled
                                                    value={Func.checkUndefine(rate.code)} />
                                            </HMS.FormWrapperInputComponent>
                                        </Wrapper>
                                        <Wrapper className="col-md-3">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.rate.refId`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`name`} onChange={(e) => this.onChange('refId', e.target.value)}
                                                    disabled
                                                    value={Func.checkUndefine(rate.refId)} />
                                            </HMS.FormWrapperInputComponent>
                                        </Wrapper>
                                        <Wrapper className="col-md-3">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.rate.order`)}
                                            >
                                                <Input placeholder="" type={`text`}
                                                    className={`form-control`}
                                                    name={`name`} onChange={(e) => this.onChange('order', Number(e.target.value))}
                                                    disabled={this.isDisableField('order')}
                                                    value={rate.order} />
                                            </HMS.FormWrapperInputComponent>
                                        </Wrapper>
                                        <Wrapper className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                isRequired={true}
                                                isValidation={true}
                                                dataValidation={rate.promotionalDescription}
                                                validation={validation.promotionalDescription}
                                                labelTitle={t(`item.rate.descriptionPromotions`)}
                                            >
                                                <Input.TextArea rows={3} placeholder="" type={`text`}
                                                    className='form-control'
                                                    disabled={this.isDisableField('promotionalDescription')}
                                                    name='promotionalDescription' onChange={(e) => this.onChange('promotionalDescription', e.target.value)}
                                                    value={rate.promotionalDescription} />
                                            </HMS.FormWrapperInputComponent>
                                        </Wrapper>
                                       
                                        <Wrapper className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.rate.cancelPolicy`)}
                                            >
                                                <Input.TextArea rows={3} placeholder="" type={`text`}
                                                    className='form-control'
                                                    disabled={true}
                                                    name='cancelPolicy' onChange={(e) => this.onChange('cancelPolicy', e.target.value)}
                                                    value={rate.cancelPolicy?.description} />
                                            </HMS.FormWrapperInputComponent>
                                        </Wrapper>
                                        <Wrapper className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={this.renderTermsDescriptionLabel()}
                                            >
                                                <Input.TextArea rows={3} placeholder="" type={`text`}
                                                    className='form-control'
                                                    disabled={this.isDisableField('termsDescription')}
                                                    name='termsDescription' onChange={(e) => this.onChange('termsDescription', e.target.value)}
                                                    value={rate.termsDescription} />
                                            </HMS.FormWrapperInputComponent>
                                        </Wrapper>
                                        <Wrapper className="col-md-6">
                                        </Wrapper>

                                        <Wrapper className="col-md-6">
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.rate.shortDescription`)}
                                            >
                                                <DescriptionRate
                                                    {...this.props}
                                                    disabled={this.isDisableField('shortDescription')}
                                                    shortDescription={rate.shortDescription}
                                                    addDescription={this._addDescription}
                                                />
                                            </HMS.FormWrapperInputComponent>
                                            <HMS.FormWrapperInputComponent
                                                labelTitle={t(`item.rate.dayOfWeek`)}
                                            >
                                                <OperatingHoursTable
                                                    t={t}
                                                    value={rate.operatingHours}
                                                    onChange={(value) => this.onChange('operatingHours', value)}
                                                    disabled={this.isDisableField('operatingHours')}
                                                />
                                            </HMS.FormWrapperInputComponent>
                                            <Wrapper className="row">
                                                <Wrapper className="col-md-6">
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.rate.typeRate`)}
                                                    >
                                                        <br />
                                                        {
                                                            rate.dc.map(typeId => <span key={typeId} ><HMS.StatusComponent color={HOTEL.TYPE_RATE[CONFIG.ENV][typeId] === 'Bundle' ? 'geekblue' : 'red'}
                                                                label={HOTEL.TYPE_RATE[CONFIG.ENV][typeId]} /></span>)
                                                        }
                                                    </HMS.FormWrapperInputComponent>
                                                </Wrapper>
                                                <Wrapper className="col-md-6">
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.rate.status`)}
                                                    >
                                                        <br />
                                                        <HMS.StatusComponent color={rate.status ? 'green' : 'red'}
                                                            label={rate.status ? this.props.t('item.rate.active') : this.props.t('item.rate.deactive')} />
                                                    </HMS.FormWrapperInputComponent>
                                                </Wrapper>
                                            </Wrapper>
                                        </Wrapper>
                                        <Wrapper className="col-md-6">
                                            <TableCancelPolicy
                                                {...this.props}
                                                cancelPolicyData={rate.cancelPolicy}
                                                refId={rate.refId || null}
                                            />
                                        </Wrapper>
                                        <Wrapper className="col-md-6 m-t-sm">
                                            <div>
                                                <div className='col-md-3 independent'>
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.rate.isIndependent`)}
                                                    // visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                                    >
                                                        <br />
                                                        <Switch checked={rate.isIndependent} onChange={(value) => this.onChange('isIndependent', value)} name={`isIndependent`} />
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                                <div className='col-md-3'>
                                                    <HMS.FormWrapperInputComponent
                                                        labelTitle={t(`item.rate.usageStatus`)}
                                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                                    >
                                                        <br />
                                                        <Switch defaultChecked={rate.usageStatus} onChange={(value) => this.onChange('usageStatus', value)} name={`usageStatus`} />
                                                    </HMS.FormWrapperInputComponent>
                                                </div>
                                            </div>
                                        </Wrapper>
                                    </div>
                                </div>
                                {action === DETAIL_ACTIONS.UPDATE && (
                                    <AutoTranslate
                                        className="wrapper-full"
                                        languageCode={rate?.languageCode || 'vi-VN'}
                                        onChange={this.onChange}
                                        targetLanguage={rate?.targetLanguage}
                                    />
                                )}
                            </div>
                        </HMS.FormActionComponent>
                    }
                    
                    
                </HMS.PageListComponent>
            }
            </Fragment>
        );
    }
}
